<template>
  <div v-if="showPopup" class="popup-overlay">
    <div class="popup">
      <p>
        You will be logged out in {{countdown}} seconds due to inactivity. Click "Stay logged in" to remain signed in.
      </p>
      <v-chip color="primary" label @click="cancelLogout">
        Stay logged in
      </v-chip>
    </div>
  </div>
</template>

<script>
import { LOGOUT } from '../store/actions.type'

const INACTIVITY_TIMEOUT = 60 * 60 * 1000 // 1 Hour
const POPUP_WARNING_TIME = 10 * 1000 // 10 seconds

export default {
  data () {
    return {
      showPopup: false, // Control the visibility of the popup
      logoutTimer: null, // Timer for logging out
      inactivityTimer: null, // Timer for inactivity
      countdown: POPUP_WARNING_TIME / 1000, // Countdown starting from POPUP_WARNING_TIME in seconds
      countdownTimer: null // Timer for updating the countdown
    }
  },
  methods: {
    showInactivityPopup () {
      this.showPopup = true
      this.countdown = POPUP_WARNING_TIME / 1000 // Reset countdown to POPUP_WARNING_TIME (in seconds)
      this.startCountdown()

      if (this.logoutTimer) {
        clearTimeout(this.logoutTimer) // clear any previous logout timer
      }
      this.logoutTimer = setTimeout(() => {
        this.logoutUser()
      }, POPUP_WARNING_TIME)
    },

    // Handle cancel button click
    cancelLogout () {
      this.showPopup = false
      clearInterval(this.countdownTimer) // Stop the countdown
      clearTimeout(this.logoutTimer) // Stop the logout process
      this.resetInactivityTimer() // Reset inactivity timer to keep the user logged in
    },

    // Log out the user (for now just log to console)
    logoutUser () {
      this.$store.dispatch(LOGOUT).then(() => {
        if (this.$store.state.auth.errors == null) {
          this.$router.push(`/login`)
        }
      })
    },

    // Reset the inactivity timer
    resetInactivityTimer () {
      clearTimeout(this.inactivityTimer)
      this.startInactivityTimer()
    },

    // Start inactivity timer
    startInactivityTimer () {
      this.inactivityTimer = setTimeout(() => {
        this.showInactivityPopup()
      }, INACTIVITY_TIMEOUT)
    },

    // Detect user activity (e.g., mouse move, keypress)
    detectUserActivity () {
      this.resetInactivityTimer()
    },

    // For showing the count down in the modal
    startCountdown () {
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1
        } else {
          clearInterval(this.countdownTimer)
        }
      }, 1000)
    }
  },
  created () {
    this.startInactivityTimer()

    // Listen for mouse movement and keypress to detect activity
    window.addEventListener('mousemove', this.detectUserActivity)
    window.addEventListener('keydown', this.detectUserActivity)
  },
  destroyed () {
    clearInterval(this.countdownTimer)
    clearTimeout(this.logoutTimer)
    clearTimeout(this.inactivityTimer)
    window.removeEventListener('mousemove', this.detectUserActivity)
    window.removeEventListener('keydown', this.detectUserActivity)
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.popup {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>
